import React from 'react'
import PropTypes from 'prop-types'

function Flashcard({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={styling}
      viewBox="0 0 20 20"
    >
      <path d="M20 2.734v14.532C20 18.776 18.8 20 17.318 20H8.145c-1.482 0-2.682-1.223-2.682-2.734v-2.374l1.976.432v1.87a.79.79 0 00.776.792h9.033a.79.79 0 00.776-.792V2.878a.791.791 0 00-.776-.792H8.215a.79.79 0 00-.776.792v5.395L5.463 8.13V6.33c-3.952 1.87-3.034 2.806-.847 3.31.283.071.565.143.847.143.635.072 1.341.144 1.976.216.423.072.847.072 1.27.072 1.412.072 2.47.072 2.47.072v-2.23c0-.36.424-.288.565-.144l4.093 2.877L17.46 11.8c.14.143.14.36 0 .575l-1.623 1.151-1.976 1.439-2.047 1.439c-.07.072-.211.144-.282.144-.07 0-.282 0-.282-.216v-1.799c-1.059-.215-2.047-.36-2.964-.575-.282-.072-.494-.144-.776-.144-.706-.144-1.412-.36-1.976-.504a30.555 30.555 0 01-1.34-.431c-10.163-3.67 1.34-7.986 1.34-7.986V2.734C5.534 1.224 6.734 0 8.215 0h9.174C18.801 0 20 1.223 20 2.734z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
Flashcard.propTypes = {
  styling: string,
}

export default Flashcard
